import type { CalagemResult, ResultTableRow } from '../../../recommendations/types';

export interface CalcularCalagemResponse {
	formaValue?: number;
	dose?: number;
	doseMax?: number;
	Ca?: number;
	Mg?: number;
	satCa?: number;
	satMg?: number;
	satSB?: number;
	pHagua?: number;
}

const numberString = (value: unknown): string => {
	if (value === null || value === undefined || value === '') return '';
	const numberValue = Number(value);
	return Number.isNaN(numberValue) ? String(value) : String(numberValue);
};

const resultRow = (
	param: string,
	unit: string,
	after: unknown,
	current = '—',
	range = '—'
): ResultTableRow => ({
	param,
	unit,
	current,
	range,
	after: numberString(after) || '—',
});

const isCalagemResult = (value: unknown): value is CalagemResult => {
	if (!value || typeof value !== 'object') return false;
	const record = value as Partial<CalagemResult>;
	return !!record.ajuste && Array.isArray(record.table);
};

export const mapCalagemResponse = (
	data: CalcularCalagemResponse | CalagemResult
): CalagemResult => {
	if (isCalagemResult(data)) return data;

	return {
		doseMax: numberString(data.doseMax),
		ajuste: {
			dose: numberString(data.dose),
			doseSecundaria: numberString(data.formaValue),
		},
		table: [
			resultRow('Ca', 'cmolc/dm³', data.Ca),
			resultRow('Mg', 'cmolc/dm³', data.Mg),
			resultRow('Sat. Ca', '%', data.satCa),
			resultRow('Sat. Mg', '%', data.satMg),
			resultRow('Sat. bases', '%', data.satSB),
			resultRow('pH água', '', data.pHagua),
		],
	};
};
